import moment from 'moment'
import React from 'react'
import Text from 'react-text'
import Links from './links'
import {enhancedWithRowData} from '../../helpers/utils'

function RollbookHeader ({title}) {
  return (
    <span><Text id={`${title}_rollbook_header`} /></span>
  )
}

function EmptyHeader () { return (<span />) }

function SubjectColumn ({rowData}) {
  const {subject, grade} = rowData
  return (
    <div className="subject">
      {`${subject} - ${grade}`}
    </div>
  )
}

function RollbookLinksColumn ({rowData}) {
  return (<Links {...rowData} />)
}

const map = {
  headers: {RollbookHeader: RollbookHeader, EmptyHeader},
  columns: {
    SubjectColumn: enhancedWithRowData(SubjectColumn),
    RollbookLinksColumn: enhancedWithRowData(RollbookLinksColumn),
  }
}

export default map
